<div class="flex w-full items-center justify-end">
  <div
    class="flex items-center"
    [ngClass]="active_link === '/a-propos' ? 'items-menu' : ''"
  >
    <a href="/a-propos" class="text-xs xl:text-base text-black items_menu"
      >Qui sommes nous ?</a
    >
  </div>
  <div class="flex items-center mx-1 lg:mx-4">
    <img src="assets/svg/separator.svg" class="h-2" />
  </div>
  <div
    class="flex items-center lg:mx-2"
    [ngClass]="active_link === '/formations' ? 'items-menu' : ''"
  >
    <a href="/formations" class="text-xs xl:text-base text-black items_menu"
      >Nos formations</a
    >
  </div>
  <div class="flex items-center mx-1 lg:mx-4">
    <img src="assets/svg/separator.svg" class="h-2" />
  </div>
  <div
    class="flex flex-col items-baseline mx-2"
    [ngClass]="active_link === '/key-figures' ? 'items-menu' : ''"
  >
    <a href="#" class="text-xs xl:text-base text-black items_menu mt-4"
      >Nos chiffres clés</a
    >
    <div
      class="
        ml-2
        lg:ml-8
        rounded-sm
        w-24
        mx-auto
        news-linear-gradient
        text-center
      "
    >
      <p class="text-xs text-white">COMING SOON</p>
    </div>
  </div>
  <div class="flex items-center mx-1 lg:mx-4">
    <img src="assets/svg/separator.svg" class="h-2" />
  </div>
  <div
    class="flex items-center mx-4"
    [ngClass]="active_link === '/contact' ? 'items-menu' : ''"
  >
    <a href="/contact" class="text-xs xl:text-base text-black items_menu"
      >Contactez-nous</a
    >
  </div>
  <div
    class="
      flex
      items-center
      mx-4
      bg-yellow
      rounded-full
      w-32
      h-10
      justify-center
      gap-6
    "
  >
    <a
      href="https://m.facebook.com/CFA-Sant%C3%A9-Martinique-110004447996015/"
      target="_blank"
    >
      <img
        src="./assets/svg/facebook.svg"
        class="w-3 xl:w-4 mx-auto hover:animate-pulse"
      />
    </a>
    <a href="https://www.instagram.com/cfasante_mq/" target="_blank">
      <img
        src="./assets/svg/instagram.svg"
        class="w-3 xl:w-4 mx-auto hover:animate-pulse"
      />
    </a>
    <a
      href="https://www.linkedin.com/company/cfa-sant%C3%A9-martinique"
      target="_blank"
    >
      <img
        src="./assets/svg/linkedin.svg"
        class="w-3 xl:w-4 mx-auto hover:animate-pulse"
      />
    </a>
  </div>
</div>
